import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=278fe5c0&scoped=true&"
import script from "./TextItem.vue?vue&type=script&lang=js&"
export * from "./TextItem.vue?vue&type=script&lang=js&"
import style0 from "./TextItem.vue?vue&type=style&index=0&id=278fe5c0&lang=scss&scoped=true&"
import style1 from "./TextItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278fe5c0",
  null
  
)

export default component.exports